<template>
  <li v-link="link" :class="classes">
    <slot></slot>
  </li>
</template>

<script>
import gsap from 'gsap'

export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    order: {
      type: Number,
      default: 0
    },
    delay: {
      type: Number,
      default: 0.2
    },
    y: {
      type: Number,
      default: -30
    },
    duration: {
      type: Number,
      default: 0.5
    },
    link: {
      type: Object,
      default () {
        return {}
      }
    },
    size: {
      type: [Boolean, String]
    }
  },
  computed: {
    formattedIndex () {
      return this.pad(this.index + 1, 2)
    },
    classes () {
      return `size-${this.size}`
    }
  },
  methods: {
    pad (number, digits) {
      return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number
    }
  },
  transitions: {
    reveal: {
      enter (el, done) {
        gsap.set(this.$el, {opacity: 0, y: this.y})
        gsap.to(el, this.duration, {opacity: 1, y: 0, onComplete: () => {
          el.style.opacity = ''
          done()
        }, delay: this.delay * this.index})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
li {
  padding: 1rem;
  margin: 1rem 0;
  cursor: pointer;
  font-size: 3.5rem;
  font-weight: bold;
  display: flex;
  align-items: flex-start;
  border: 2px solid transparent;
  cursor: pointer;

  /* &.size {
    &-small { */
  font-size: 2.5rem;
  padding: .5rem;
  padding-left: 0;
  margin: .5rem 0;
    /* }
  } */

  &.v-link-active {
    opacity: .25;
  }

  &.sortable-ghost {
    border-style: dashed;
    border-color: black;
    color: transparent;
    opacity: .5;
  }

  &:hover {
    opacity: .25;
  }

  .index {
    width: 2rem;
    font-size: 1rem;
    // margin-left: -3rem;
    margin-right: 1rem;
    margin-top: 1rem;
    text-align: right;
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// ListItem.vue?5437d19d